<!--
  Profile menu — matches gigsumo_unified(48).html lines 1397–1463.
  Wraps the reusable <gs-dropdown> shell; panel body reproduces the
  mock's header banner + grouped rows + danger row + footer strip.
-->
<gs-dropdown #dd class="gs-theme" align="right" width="268px" (openChange)="toggled.emit($event)">

  <!-- Trigger: avatar circle (initials or photo) — preserves existing nav-bar avatar look. -->
  <button gs-dd-trigger type="button"
          class="pm-trigger"
          [class.has-photo]="!!user.photo"
          [style.background]="user.photo ? null : (user.avatarBg || 'linear-gradient(135deg,#EDE9FE,#DDD6FE)')"
          [style.color]="user.avatarFg || '#6D28D9'"
          [attr.title]="(user.fullName || '') + (user.userTypeLabel ? ', ' + user.userTypeLabel : '') + (user.companyName ? ' @ ' + user.companyName : '')">
    <img *ngIf="user.photo" [src]="user.photo" alt="avatar" class="pm-trigger-img" />
    <span *ngIf="!user.photo" class="pm-trigger-initials">{{ user.initials || '?' }}</span>
  </button>

  <!-- Panel body -->
  <div gs-dd-panel class="pm-panel">

    <!-- ── Profile banner (fixed at top) ── -->
    <div class="av-dd-profile">
      <div class="av-dd-av"
           [style.background]="user.avatarBg || 'linear-gradient(135deg,#EDE9FE,#DDD6FE)'"
           [style.color]="user.avatarFg || '#6D28D9'">
        <ng-container *ngIf="user.photo; else initialsBlock">
          <img [src]="user.photo" alt="avatar" />
        </ng-container>
        <ng-template #initialsBlock>{{ user.initials || '?' }}</ng-template>
        <div class="av-dd-online" *ngIf="user.online !== false"></div>
      </div>
      <div class="av-dd-info">
        <div class="av-dd-name">
          <span class="av-dd-name-text">{{ user.fullName }}</span>
          <span class="av-dd-plan" *ngIf="user.plan">{{ user.plan }}</span>
        </div>
        <div class="av-dd-email" *ngIf="user.email" [title]="user.email">{{ user.email }}</div>
        <div class="av-dd-uid" *ngIf="user.gigsumoNo || user.userTypeLabel">
          <ng-container *ngIf="user.gigsumoNo">{{ user.gigsumoNo }}</ng-container>
          <ng-container *ngIf="user.gigsumoNo && user.userTypeLabel"> · </ng-container>
          <ng-container *ngIf="user.userTypeLabel">{{ user.userTypeLabel }}</ng-container>
        </div>
      </div>
    </div>

    <!-- ── Scrollable middle (groups) ── -->
    <div class="pm-scroll">

    <!-- ── Group: Profile & Company ── -->
    <div class="gs-dd-group">
      <button type="button" class="gs-dd-item" (click)="onViewProfile()">
        <span class="gs-dd-icon"><ng-icon name="tablerUser"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">My Profile</span>
          <span class="gs-dd-item-sub">View and edit your public profile</span>
        </span>
      </button>
      <button type="button" class="gs-dd-item" *ngIf="user.companyName" (click)="onOpenCompany()">
        <span class="gs-dd-icon"><ng-icon name="tablerBuilding"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">{{ user.companyName }}</span>
          <span class="gs-dd-item-sub">Company workspace</span>
        </span>
      </button>
    </div>

    <!-- ── Group: Settings & Admin (hidden for JOB_SEEKER) ── -->
    <div class="gs-dd-group" *ngIf="user.userType !== 'JOB_SEEKER'">
      <button type="button" class="gs-dd-item" (click)="onOpenAdmin()">
        <span class="gs-dd-icon"><ng-icon name="tablerShield"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">Admin</span>
          <span class="gs-dd-item-sub">Manage users &amp; permissions</span>
        </span>
        <span class="gs-dd-kbd">⌘A</span>
      </button>
      <button type="button" class="gs-dd-item" (click)="onOpenPlans()">
        <span class="gs-dd-icon"><ng-icon name="tablerCreditCard"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">Plans &amp; Pricing</span>
          <span class="gs-dd-item-sub">Upgrade for more slots &amp; AI Credits</span>
        </span>
        <span class="gs-dd-badge pro" *ngIf="user.plan">{{ user.plan }}</span>
      </button>
    </div>

    <!-- ── Group: Help ── -->
    <div class="gs-dd-group">
      <button type="button" class="gs-dd-item" (click)="onOpenFaq()">
        <span class="gs-dd-icon"><ng-icon name="tablerHelp"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">FAQ</span>
          <span class="gs-dd-item-sub">Frequently asked questions</span>
        </span>
      </button>
      <button type="button" class="gs-dd-item" (click)="onOpenSupport()">
        <span class="gs-dd-icon"><ng-icon name="tablerMessage"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">Support</span>
          <span class="gs-dd-item-sub">Chat with our team</span>
        </span>
      </button>
    </div>

    <!-- ── Sign out ── -->
    <div class="gs-dd-group">
      <button type="button" class="gs-dd-item danger" (click)="onLogout()">
        <span class="gs-dd-icon"><ng-icon name="tablerLogout"></ng-icon></span>
        <span class="gs-dd-item-text">
          <span class="gs-dd-item-title">Sign Out</span>
        </span>
      </button>
    </div>

    </div><!-- /.pm-scroll -->

    <!-- ── Footer strip (fixed at bottom) ── -->
    <!-- Upgrade pill hides for JOB_SEEKER and for users already on the highest
         plan (ScaleX) — mirrors user-badge.component.html:126 so the two
         "upgrade" surfaces stay in sync. -->
    <div class="gs-dd-strip">
      <span class="gs-dd-strip-text">gigsumo.com · v{{ versions }}</span>
      <span class="gs-dd-upgrade"
            *ngIf="user?.userType !== 'JOB_SEEKER' && user?.plan !== highestPlan"
            (click)="onUpgradePlan(); $event.stopPropagation()">Upgrade Plan →</span>
    </div>

  </div>
</gs-dropdown>
